module.exports = __webpack_public_path__ + "img/1206.17a799cc.jpg";